import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { EnterpriseGuard } from './guards/enterprise.guard';
import { environment } from '../environments/environment';

const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  {
    path: 'home',
    title: environment.title + 'Accueil',
    loadChildren: () =>
      import('./pages/home/home.module').then((m) => m.HomePageModule),
  },
  {
    path: 'dashboard',
    title: environment.title + 'Tableau de bord',
    loadChildren: () =>
      import('./pages/dashboard/dashboard.module').then(
        (m) => m.DashboardPageModule
      ),
    canActivate: [AuthGuard, EnterpriseGuard],
  },
  {
    path: 'registration',
    title: environment.title + 'Inscription',
    loadChildren: () =>
      import('./pages/registration/registration.module').then(
        (m) => m.RegistrationPageModule,
      ),
  },
  {
    path: 'access',
    title: environment.title + 'Accès',
    loadChildren: () =>
      import('./pages/access/access.module').then((m) => m.AccessPageModule),
  },
  {
    path: 'onboarding',
    title: environment.title + 'Onboarding',
    loadChildren: () =>
      import('./pages/onboarding/onboarding.module').then(
        (m) => m.OnboardingPageModule
      ),
  },
  {
    path: 'select-enterprise',
    title: environment.title + 'Sélectionner une entreprise',
    loadChildren: () =>
      import('./pages/select-enterprise/select-enterprise.module').then(
        (m) => m.SelectEnterprisePageModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'password-reset',
    title: environment.title + 'Réinitialiser le mot de passe',
    loadChildren: () =>
      import('./pages/password-reset/password-reset.module').then(
        (m) => m.PasswordResetPageModule
      ),
  },
  {
    path: 'documents/:uuid',
    title: environment.title + 'Document(s) partagé(s)',
    loadChildren: () =>
      import('./pages/share/share.module').then((m) => m.SharePageModule),
  },
  {
    path: 'terms/:type',
    title: environment.title + "Conditions d'utilisation",
    loadChildren: () =>
      import('./pages/terms/terms.module').then((m) => m.TermsPageModule),
  },
  { path: '**', redirectTo: 'home' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
